module.exports = __webpack_public_path__ + "img/adobe-10.69313857.png";